export default __webpack_public_path__ + "static/media/blockchain-big.4d756eb1.png";